"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  height: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0, 0, 0, 0.1);\n  color: var(--color-grey-dark-3);\n  font-weight: bold;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.75em;\n  display: flex;\n  flex-direction: column;\n\n  & > [data-meta='image-explanation-option'],\n  & > [data-meta='add-image-explanation-option'] {\n    height: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var image_explanation_option_view_styles_1 = require("../image-explanation-option-view/image-explanation-option-view.styles");

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

exports.StyledImageExpNodeWrapperDiv = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme.fontSize.default + 'rem';
});
exports.StyledImageExpNodeWrapperDiv.defaultProps = {
  theme: scenario_node_view_styles_1.DEFAULT_SCENARIO_NODE_THEME
};
exports.StyledImageExpOptionsUl = styled_components_1.default.ul(_templateObject2());
exports.StyledImageExpOptionLi = styled_components_1.default.li(_templateObject3());
var emmptyMessageHeight = 40;
exports.StyledEmptyMessageP = styled_components_1.default.p(_templateObject4(), function (props) {
  return image_explanation_option_view_styles_1.initImageExpOptionShapeStyle(props.theme.scale);
}, function (props) {
  return props.theme.scale * emmptyMessageHeight + 'rem';
});